<template>
  <div class="menu-item" :class="modifiers">
    <button
      class="menu-item__button"
      type="button"
      :disabled="disabled"
      v-on="$listeners"
    >
      <span class="menu-item__inner">
        <BaseIcon
          v-if="icon"
          v-bind="icon"
          class="menu-item__icon"
        />
        <BaseTitle
          v-if="label"
          tag="b"
          v-bind="label"
          class="menu-item__text"
        />
        <slot />
      </span>
    </button>
  </div>
</template>

<script>
import BaseIcon from '@/components/BaseIcon.vue';
import BaseTitle from '@/components/BaseTitle.vue';

export default {
  name: 'BaseMenuItem',
  inheritAttrs: false,
  components: {
    BaseIcon,
    BaseTitle,
  },
  props: {
    icon: {
      type: Object,
      default: null,
    },
    label: {
      type: Object,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isInline: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    modifiers() {
      return {
        'menu-item_inline': this.isInline,
      };
    },
  },
};
</script>

<style lang="stylus">
.menu-item
  display block
  position relative
  border-radius 0.5em
  &:before
    content ''
    display block
    abs top left right bottom
    background-color $c_primary
    opacity 0.2
    margin 0.25em -0.25em -0.25em 0.25em
    border-radius inherit
    z-index 0

  &__button
    position relative
    display flex
    align-items center
    width 100%
    height 100%
    font-family inherit
    text-decoration none
    font-size 1em
    font-weight 400
    line-height 1
    text-align center
    background-color $c_light
    padding 1em
    box-shadow inset 0 0 0 0.2em alpha($c_primary, 40%)
    transition transform 100ms ease-out
    border-radius inherit
    outline none
    border 0
    z-index 1
    &[disabled]
      transform translate(0.25em, 0.25em)
      box-shadow inset 0 0 0 0.2em $c_dim
      color $c_dim
    &:active:not([disabled])
      transform translate(0.25em, 0.25em)

  &__icon
    margin 0 auto
    margin-bottom 1.5em
    ~/_inline &
      margin-bottom 0
      margin-right 1em

  &__inner
    width 100%
    ~/_inline &
      display flex
      align-items center
</style>
